var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/ProductsMenu.js",
  _this = this;
import React, { useContext } from 'react';
import { t } from '@sm/intl';
import NavSubmenuCopy from '../../copy/NavSubmenuCopy';
import Menu from './components/Menu.js';
import SubMenu from './components/SubMenu';
import SubMenuBody from './components/SubMenuBody.js';
import BottomLinkWrapper from './components/BottomLinkWrapper.js';
import BottomLink from './components/BottomLink.js';
import ColumnTitle from './components/ColumnTitle.js';
import SubMenuItem from './components/SubMenuItem.js';
import Column from './components/Column.js';
import SMHeaderContext from '../../SMHeaderContext';
import { surveys, surveymonkey, enterprise, integrations, specializedProducts, audience, cx, engage, usabilla, formsWorkFlows, none, techValidate, apply, wufoo, getFeedback, viewAllProducts, addIntegrations, productsMenu } from '../../config/linkInfo.js';
export var ProductMenu = function ProductMenu() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang,
    isEUDC = _useContext.isEUDC;
  var key = 'Products';
  var subMenuTitle = t(NavSubmenuCopy.PRODUCTS_TITLE);
  return /*#__PURE__*/React.createElement(Menu, Object.assign({
    menuKey: key
  }, productsMenu(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SubMenu, {
    submenuKey: key,
    title: subMenuTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SubMenuBody, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, lang === 'en' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, surveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, surveymonkey(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, enterprise(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, integrations(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, specializedProducts(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 17
    }
  })), !isEUDC ? /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, audience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 28
    }
  })) : null, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, cx(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, engage(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, usabilla(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, none(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, techValidate(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, apply(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, wufoo(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, getFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 17
    }
  })))) : lang === 'fr' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, surveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, surveymonkey(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, audience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(ColumnTitle, Object.assign({}, formsWorkFlows(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, apply(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, usabilla(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 17
    }
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, surveymonkey(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, audience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(SubMenuItem, Object.assign({}, usabilla(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 17
    }
  }))))), /*#__PURE__*/React.createElement(BottomLinkWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(BottomLink, Object.assign({}, viewAllProducts(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  })), lang !== 'en' ? /*#__PURE__*/React.createElement(BottomLink, Object.assign({}, addIntegrations(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 28
    }
  })) : null)));
};
export default ProductMenu;
//# sourceMappingURL=ProductsMenu.js.map